import { useEffect, useState } from 'react';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import usePageMeta from '../../../hooks/usePageMeta';

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  usePageMeta({
    title: '미래인재학원 자주 하는 질문',
    description: '미래인재학원에 대해 자주 묻는 질문과 답변을 확인하세요. 수강 신청, 수업 안내, 레벨 테스트 등 궁금한 점을 빠르게 해결할 수 있습니다.',
    path: '/news/faq',
    schemaType: 'FAQPage',
    keywords: '미래인재학원 FAQ, 자주하는 질문, 수강 신청, 레벨 테스트, 반 배정, 학원비, 환불',
  });

  const faqs = [
    {
      question: '수강 시작 절차는 어떻게 되나요?',
      answer: '상담 → 레벨테스트 → 반배정 → 등록 → 수업시작 순으로 진행됩니다.\n\n1. 전화 또는 방문 상담 진행\n2. 레벨 테스트 실시 (필요 시)\n3. 학생 수준에 맞는 반 배정 (주말제외, 1~2일 소요)\n4. 결과 안내 및 등록, 수강료 납부\n5. 수업 시작'
    },
    {
      question: '학생이 해당 학년 S반 진도보다 더 나가고 싶을 땐 어떻게 해야 하나요?',
      answer: '해당 학년 S반보다 더 빠른 선행 진도를 나가고 싶을 때는, 테스트 후 월반이 가능합니다. 예를 들어 중2 S반이 고1 1학기 과정을 진행하고 있을 때, 고1 과정을 다 마치고 고2 과정을 원한다면 테스트 후 학년 월반이 가능합니다.'
    },
    {
      question: '형제자매가 함께 다닐 때, 할인 혜택이 있나요?',
      answer: '네, 있습니다. 형제자매가 함께 다니는 경우 수강하는 과목 수에 맞춰 할인 혜택이 적용됩니다. (영어,수학 과목에만 적용됩니다)\n\n예를 들어,\n• 첫째가 2과목, 둘째가 추가로 2과목을 듣는 경우에는 둘째에게 4만 원 할인 혜택이 적용됩니다.\n• 첫째가 2과목, 둘째가 추가로 1과목을 듣는 경우에는 둘째에게만 2만 원 할인 혜택이 적용됩니다.\n• 첫째가 1과목, 둘째가 추가로 1과목을 듣는 경우에는 둘째에게만 1만 원 할인 혜택이 적용됩니다.\n\n자세한 사항은 학원으로 전화 주시면 친절히 설명해 드리겠습니다.'
    },
    {
      question: '학원비 환불 규정은 어떻게 되나요?',
      answer: '교육청에서 정한 환불 지침을 따르고 있습니다. 자세한 사항은 학원으로 문의해 주세요.'
    },
    {
      question: '선생님과의 상담은 어떻게 진행되나요?',
      answer: '1년에 4번 정기 상담 시즌이 있습니다. 정기 상담 시즌 외에도 언제든지 궁금하신 점이 있으실 때 학원으로 연락 주시면, 담당 선생님께서 바로 회신해 드리고 있습니다.'
    },
    {
      question: '레벨 테스트는 어떻게 진행되며, 반 배정 기준은 무엇인가요?',
      answer: '레벨 테스트는 학기 시즌에 맞춰 매번 개정되고 있으며, 주로 학원에서 진행한 월간고사 문제들로 출제하고 있습니다. 레벨 테스트 후 담당 선생님께서 학생의 시험 결과를 직접 검토한 뒤 반 레벨을 지정합니다.'
    },
    {
      question: '레벨 이동은 어떻게 진행되나요?',
      answer: '1년에 2~3번 학원에서 미리 공지하여, 대대적으로 레벨을 재배정하는 시험을 진행합니다.'
    },
    {
      question: '간혹 레벨이 맞지 않은 경우도 있을 것 같은데, 이런 경우는 어떻게 하나요?',
      answer: '레벨 테스트 결과로만 판단하다 보면 이러한 경우가 가끔 발생합니다. 이럴 땐 담당 선생님께서 학생의 학업 성취도를 직접 판단하여 레벨을 조정해주십니다.'
    }
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation currentPage="faq" />

      {/* Hero */}
      <section className="pt-20 relative min-h-[200px] md:min-h-[320px] flex items-center">
        <div className="absolute inset-0 bg-black">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(251,191,36,0.12)_0%,transparent_50%)]"></div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(251,191,36,0.08)_0%,transparent_40%)]"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16 w-full">
          <div className="max-w-2xl">
            <span className="text-yellow-400 font-semibold text-xs md:text-sm tracking-wider uppercase">
              FAQ
            </span>
            <h1 className="text-2xl md:text-5xl font-bold text-white mt-2 md:mt-4 mb-2 md:mb-4">
              미래인재학원 자주하는 질문
            </h1>
            <p className="text-sm md:text-lg text-gray-300 leading-relaxed">
              학부모님들이 자주 묻는 질문과 답변을 모았습니다
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Content Section */}
      <section className="py-12 md:py-20 px-3 md:px-4">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-xl overflow-hidden bg-white hover:border-yellow-400 transition-colors"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-5 md:px-6 py-4 md:py-5 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-start gap-3 md:gap-4 flex-1 min-w-0">
                    <div className="w-6 h-6 md:w-7 md:h-7 bg-yellow-400 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-black font-bold text-sm md:text-base">Q</span>
                    </div>
                    <span className="text-sm md:text-base font-semibold text-gray-900 leading-relaxed">
                      {faq.question}
                    </span>
                  </div>
                  <div className="flex-shrink-0">
                    <i
                      className={`ri-arrow-down-s-line text-xl md:text-2xl text-gray-400 transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 md:px-6 pb-4 md:pb-5 pt-2">
                    <div className="flex items-start gap-3 md:gap-4 pl-0 md:pl-0">
                      <div className="w-6 h-6 md:w-7 md:h-7 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-bold text-sm md:text-base">A</span>
                      </div>
                      <div className="text-sm md:text-base text-gray-600 leading-relaxed whitespace-pre-line flex-1">
                        {faq.answer}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
